import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'

import learningPath from './slices/learningPath'
import profiles from './slices/profiles'
import webinars from './slices/webinars'
import questionBank from './slices/questionBank'

import { createRootReducer } from './reducers'
import { history } from './history'
import rootSaga from './sagas/root.saga'

// Middlewares
const sagaMiddleware = createSagaMiddleware()
const middleware: any[] = [sagaMiddleware, routerMiddleware(history)]

// Create store using Redux Toolkit with custom enhancers
export const store = configureStore({
  reducer: createRootReducer({
    learningPath,
    profiles,
    webinars,
    questionBank,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: true }).concat(middleware),
})

// Run sagas

sagaMiddleware.run(rootSaga)

// Types
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
